import React, { useState, useEffect } from "react";
import DashboardContainer from "../../../Dashboard_en/DashboardContainer";
import DashboardContainerHeader from "../../../Dashboard_en/Components/DashboardContainerHeader/DashboardContainerHeader";
import axios from "axios";
import ApiName from "../../../ApiName";
import { Plus, Trash2 } from "lucide-react";

const AdminCategories = () => {
  const [categories, setCategories] = useState([]);
  const [newCategoryName, setNewCategoryName] = useState("");
  const [newSubCategoryNames, setNewSubCategoryNames] = useState({});

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(ApiName + "/Category");
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  };

  const handleAddCategory = async (e) => {
    e.preventDefault();
    if (!newCategoryName.trim()) return;
    try {
      await axios.post(
        ApiName + "/Category",
        { name: newCategoryName },
        { headers: { Authorization: localStorage.authToken } }
      );
      setNewCategoryName("");
      fetchCategories();
    } catch (error) {
      console.error("Error adding category", error);
    }
  };

  const handleDeleteCategory = async (id) => {
    if (!window.confirm("Are you sure you want to delete this category?")) return;
    try {
      await axios.delete(ApiName + "/Category/" + id, {
        headers: { Authorization: localStorage.authToken },
      });
      fetchCategories();
    } catch (error) {
      console.error("Error deleting category", error);
    }
  };

  const handleAddSubCategory = async (e, categoryId) => {
    e.preventDefault();
    const name = newSubCategoryNames[categoryId];
    if (!name || !name.trim()) return;
    try {
      await axios.post(
        ApiName + "/Category/subcategory",
        { name, categoryId },
        { headers: { Authorization: localStorage.authToken } }
      );
      setNewSubCategoryNames({ ...newSubCategoryNames, [categoryId]: "" });
      fetchCategories();
    } catch (error) {
      console.error("Error adding subcategory", error);
    }
  };

  const handleDeleteSubCategory = async (id) => {
    if (!window.confirm("Are you sure you want to delete this subcategory?")) return;
    try {
      await axios.delete(ApiName + "/Category/subcategory/" + id, {
        headers: { Authorization: localStorage.authToken },
      });
      fetchCategories();
    } catch (error) {
      console.error("Error deleting subcategory", error);
    }
  };

  return (
    <div className="px-5 pb-10">
      <DashboardContainer classNames={"text-zinc-900"} text="Manage Categories">
        <DashboardContainerHeader text="Manage Categories" />
        <div className="p-5">
          <form onSubmit={handleAddCategory} className="flex gap-2 mb-8">
            <input
              type="text"
              value={newCategoryName}
              onChange={(e) => setNewCategoryName(e.target.value)}
              placeholder="New Category Name (e.g. Exhibition 2023)"
              className="flex-1 p-2 border border-gray-300 rounded dark:bg-gray-800 dark:border-gray-600 dark:text-white"
            />
            <button
              type="submit"
              className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 flex items-center gap-2"
            >
              <Plus size={16} /> Add Category
            </button>
          </form>

          <div className="space-y-6">
            {categories.map((category) => (
              <div key={category.id} className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow border border-gray-200 dark:border-gray-700">
                <div className="flex justify-between items-center mb-4 pb-2 border-b border-gray-100 dark:border-gray-700">
                  <h3 className="text-xl font-bold dark:text-white">{category.name}</h3>
                  <button
                    onClick={() => handleDeleteCategory(category.id)}
                    className="p-2 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded"
                  >
                    <Trash2 size={18} />
                  </button>
                </div>

                <div className="pl-4 space-y-2">
                  <h4 className="text-sm font-semibold text-gray-500 dark:text-gray-400">Subcategories</h4>
                  {category.subCategories && category.subCategories.length > 0 ? (
                    <ul className="space-y-2 mb-4">
                      {category.subCategories.map((sub) => (
                        <li key={sub.id} className="flex justify-between items-center bg-gray-50 dark:bg-gray-700/50 p-2 rounded">
                          <span className="dark:text-gray-200">{sub.name}</span>
                          <button
                            onClick={() => handleDeleteSubCategory(sub.id)}
                            className="p-1 text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 rounded"
                          >
                            <Trash2 size={14} />
                          </button>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-sm text-gray-400 italic mb-4">No subcategories yet.</p>
                  )}

                  <form onSubmit={(e) => handleAddSubCategory(e, category.id)} className="flex gap-2 mt-2">
                    <input
                      type="text"
                      value={newSubCategoryNames[category.id] || ""}
                      onChange={(e) => setNewSubCategoryNames({ ...newSubCategoryNames, [category.id]: e.target.value })}
                      placeholder="New Subcategory..."
                      className="flex-1 p-2 text-sm border border-gray-300 rounded dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                    />
                    <button
                      type="submit"
                      className="px-3 py-2 text-sm bg-gray-200 text-gray-800 rounded hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600 flex items-center gap-1"
                    >
                      <Plus size={14} /> Add
                    </button>
                  </form>
                </div>
              </div>
            ))}
            {categories.length === 0 && (
              <p className="text-gray-500 dark:text-gray-400 text-center py-8">No categories found. Create one above.</p>
            )}
          </div>
        </div>
      </DashboardContainer>
    </div>
  );
};

export default AdminCategories;
